import { useContext, useEffect } from "react";
import { UserContext } from "./context/Context";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"; // Import the correct routing components
import axios from "axios";
import Home from "./pages/Home/Home";
import Answer from "./pages/Answer/Answer";
import AskQuestion from "./pages/AskQuestion/AskQuestion";
import SignUp from "./pages/Signup/SignUp";
import Login from "./pages/Login/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Nav from "./components/Nav/Nav";
import Footer from "./components/Footer/Footer";

function App() {
  const [, setUserData] = useContext(UserContext);
  const apiBaseUrl =
    process.env.REACT_APP_API_BASE_URL || "http://localhost:5001";

  const logout = () => {
    try {
      // Use setUserData to update the state
      setUserData({
        token: undefined,
        user: undefined,
      });
      // Other logout logic
      localStorage.setItem("auth-token", "");
    } catch (error) {
      // Handle the error here
      console.error("Error while logging out:", error);
    }
  };

  useEffect(() => {
    const checkLoggedIn = async () => {
      const token = localStorage.getItem("auth-token");
      if (!token) {
        setUserData({ token: undefined, user: undefined });
        return;
      }

      try {
        const userRes = await axios.get(`${apiBaseUrl}/api/users/`, {
          headers: { "x-auth-token": token },
        });
        setUserData({
          token,
          user: {
            id: userRes.data.data.user_id,
            display_name: userRes.data.data.user_name,
          },
        });
      } catch (error) {
        localStorage.setItem("auth-token", "");
        setUserData({ token: undefined, user: undefined });
        console.error("Error checking user login:", error);
      }
    };

    checkLoggedIn();
  }, [setUserData, apiBaseUrl]);

  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Nav logout={logout} />

        <main className="flex-1">
          <Routes>
            {/* Define your routes here */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/answer/:questionId"
              element={
                <ProtectedRoute>
                  <Answer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/askquestion"
              element={
                <ProtectedRoute>
                  <AskQuestion />
                </ProtectedRoute>
              }
            />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
